import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function AIMap() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("ai");
  }, [setStyleEditorView]);

  return null;
}
